exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#hair-color-bar-reviews[data-v-7c096171] {\n  padding: 3rem 0;\n}\n@media only screen and (min-width: 960px) {\n#hair-color-bar-reviews[data-v-7c096171] {\n    padding: 5em 3.75em;\n}\n}\n#hair-color-bar-reviews h2[data-v-7c096171] {\n  padding: 1.3rem;\n}\n@media only screen and (min-width: 960px) {\n#hair-color-bar-reviews h2[data-v-7c096171] {\n    padding: 0;\n}\n}\n", ""]);

// exports
